// import ssoImg1 from "./../../../../assets/images/708.png"; // Adjust the path as necessary
// import ssoImg2 from "./../../../../assets/images/283.png"; // Adjust the path as necessary
import img01 from "./../../../assets/images/WelfareCrew.png";// Adjust the path as necessary

function CrewComplaints() {
  return (
    <>
      {/* <div className="service-title font-700 mb-3 text-uppercase">
        Seafarer Welfare
        <span className="text-orange-ef3e33 font-400"> Crew complaints</span>
      </div> */}

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
           <div className="service-title font-700 mb-3 text-uppercase">
        {/* Seafarer Welfare */}Crew
        <span className="text-orange-ef3e33 font-400"> Crew complaints</span>
      </div>

          <p className="text-primary-color mb-3">
           There are two conventions concerned with maritime labour issues, the Working in Fishing Convention C188, 2007 and the Maritime Labour Convention, 2006. The objectives of both the Conventions are to ensure that seafarers have decent working conditions on board vessels. South Africa as a party to these Conventions has an obligation to enforce both the Conventions on any vessel flying its flag or any foreign vessel within its territory. 
          </p>

          {/* <p className="text-primary-color mb-3 font-600">
           Seafarers are encouraged to report any complaints by following their company’s Onboard Complaint Procedures and escalate to SAMSA if you are unhappy with the handling or wish to challenge the outcome of the case. However, seafarers have a right to report any issue directly to SAMSA or any Authority if they feel the issue warrants urgent intervention (i.e. sexual assault, violence etc) or feel intimidated to report to the line management or company. 
          </p> */}

          {/* <ul class="green-star-ul">
            <li>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in Marine Notice No. 48 of 2020 – Onboard Complaints Procedure. </li>
              
          </ul>   */}
          
               

        </div>
        <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
            {/* <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div> */}
          </div>        
        </div>
         
      </div>
      <ul class="green-star-ul">
             <li style={{ display: 'block' }}>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in <a href="/Documents/GBV/MN48of2020.pdf" target="_blank" rel="noopener noreferrer">Marine Notice No. 48 of 2020</a> – Onboard Complaints Procedure                                       
             </li>
            <li style={{ display: 'block' }}>In reporting complaints falling outside the MLC i.e. fishing vessels, report the complaint to the company by following company’s procedures and if not satisfied contact any SAMSA office nearest to you, alternatively you can forward your complaint to <a href="mailto:welfare@samsa.org.za ">welfare@samsa.org.za </a></li>
                 
          </ul>  
      <p className="text-primary-color mb-3">
          Seafarers are encouraged to report any complaints by following their company’s Onboard Complaint Procedures and escalate to SAMSA if you are unhappy with the handling or wish to challenge the outcome of the case. However, seafarers have a right to report any issue directly to SAMSA or any Authority if they feel the issue warrants urgent intervention (i.e. sexual assault, violence etc) or feel intimidated to report to the line management or company. 
          </p>
      <p className="text-primary-color">
          Please note SAMSA’s jurisdiction is limited to South African flagged vessels and foreign vessels which at the time of the incident is/was in South African territory. 
          </p>  

    </>
  );
}
export default CrewComplaints;